// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The search provider registry token.
 */
export const ISearchProviderRegistry = new Token('@jupyterlab/documentsearch:ISearchProviderRegistry', `A service for a registry of search
  providers for the application. Plugins can register their UI elements with this registry
  to provide find/replace support.`);
//# sourceMappingURL=tokens.js.map